import Chip from "@mui/material/Chip";
import Paper from "@mui/material/Paper";
import { Employee, Product, ProductCategory, ProductMainCategory } from "../../types";
import styled from "styled-components";
import { useState } from "react";
import { useGetProductCategories } from "../../hooks/productCategoryHooks";
import { useGetProductMainCategories } from "../../hooks/productMainCategoryHooks";
import React from "react";
import {
    Card,
    CardActions,
    FormControl,
    MenuItem,
    Select,
    SelectChangeEvent,
    Typography,
} from "@mui/material";
import { Shapes } from "lucide-react";

type Props = {
    product: Product;
    setProduct: (product: Product) => void;
    productCategories: ProductCategory[];
    productMainCategories: ProductMainCategory[];
    handleProductCategoryChange: (data: ProductCategory) => void;
    employee: Employee | undefined;
};
export type Translatable = {
    name: string;
    nameEN?: string | null;
    nameNO?: string | null;
    nameDK?: string | null;
    nameFI?: string | null;
};
export const ProductCategoryForm = (props: Props) => {
    const [openCategoryId, setOpenCategoryId] = useState<string | null>(null);
    const [selectedMainCategory, setSelectedMainCategory] = React.useState<string | null>(null);
    // const [language, setLanguage] = useState<"sv" | "en" | "no" | "dk" | "fi">("sv");

    // const getTranslatedName = <T extends Translatable>(item: T): string => {
    //     const map: Record<typeof language, keyof Translatable> = {
    //         sv: "name",
    //         en: "nameEN",
    //         no: "nameNO",
    //         dk: "nameDK",
    //         fi: "nameFI",
    //     };

    //     const key = map[language];
    //     const value = item[key];

    //     if (typeof value === "string" && value.trim().length > 0) {
    //         return value;
    //     }

    //     return item.name;
    // };

    return (
        <Container>
            <Card
                variant="outlined"
                sx={{
                    borderRadius: "30px",
                    width: "90%",
                    overflowY: "auto",
                    maxHeight: "80vh",
                    padding: "5px",
                    marginBottom: "30px",
                }}
            >
                <StyledCardActions>
                    <IconActionsWrapper>
                        <Shapes />{" "}
                        <Typography
                            fontFamily={"'Poppins', sans-serif"}
                            fontSize={18}
                            color="#8c8c8c"
                            fontWeight={600}
                        >
                            Product Type
                        </Typography>
                    </IconActionsWrapper>
                    {/* <FormControl size="small">
                        <Select
                            value={language}
                            // onChange={e => setLanguage(e.target.value)}
                            onChange={(e: SelectChangeEvent<"sv" | "en" | "no" | "dk" | "fi">) =>
                                setLanguage(e.target.value as "sv" | "en" | "no" | "dk" | "fi")
                            }
                            sx={{
                                minWidth: 120,
                                fontFamily: "'Poppins', sans-serif",
                            }}
                        >
                            <MenuItem value="sv">Swedish</MenuItem>
                            <MenuItem value="en">English</MenuItem>
                            <MenuItem value="no">Norwegian</MenuItem>
                            <MenuItem value="dk">Danish</MenuItem>
                            <MenuItem value="fi">Finnish</MenuItem>
                        </Select>
                    </FormControl> */}
                </StyledCardActions>
                <ChipsContainer>
                    {props.productMainCategories?.map(mainCategory => (
                        <Chip
                            key={mainCategory.id}
                            clickable
                            // label={mainCategory.name}
                            // label={getTranslatedName(mainCategory)}
                            label={(() => {
                                switch (props.employee?.language) {
                                    case "en":
                                        return mainCategory.nameEN;
                                    case "no":
                                        return mainCategory.nameNO;
                                    case "dk":
                                        return mainCategory.nameDK;
                                    case "fi":
                                        return mainCategory.nameFI;
                                    case "sv":
                                        return mainCategory.name;
                                    default:
                                        return mainCategory.nameEN;
                                }
                            })()}
                            onClick={() => {
                                if (selectedMainCategory === mainCategory.id) {
                                    setSelectedMainCategory(null); // Stäng om man klickar på samma
                                } else {
                                    setSelectedMainCategory(mainCategory.id); // Öppna ny
                                }
                            }}
                            color={selectedMainCategory === mainCategory.id ? "primary" : "default"}
                            sx={{
                                fontFamily: '"Yllw Sans a1 241219", sans-serif',

                                backgroundColor:
                                    selectedMainCategory === mainCategory.id ? "black" : "white",

                                border: "1px solid black",
                            }}
                        />
                    ))}
                </ChipsContainer>
            </Card>
            {selectedMainCategory && (
                <Card
                    variant="outlined"
                    sx={{
                        borderRadius: "30px",
                        width: "90%",
                        overflowY: "auto",
                        maxHeight: "80vh",
                        padding: "5px",
                        marginBottom: "30px",
                    }}
                >
                    <StyledCardActions>
                        <IconActionsWrapper>
                            <Shapes />{" "}
                            <Typography
                                fontFamily={"'Poppins', sans-serif"}
                                fontSize={18}
                                color="#8c8c8c"
                                fontWeight={600}
                            >
                                Subcategory
                            </Typography>
                        </IconActionsWrapper>
                    </StyledCardActions>
                    <ChipsContainer>
                        {props.productCategories
                            ?.filter(data => data.category === selectedMainCategory)
                            .map(data => (
                                <Chip
                                    key={data.id}
                                    clickable
                                    onClick={() => {
                                        props.handleProductCategoryChange(data);
                                    }}
                                    color={
                                        props.product.categories?.includes(data.id)
                                            ? "primary"
                                            : "default"
                                    }
                                    // label={data.name}
                                    // label={getTranslatedName(data)}
                                    label={(() => {
                                        switch (props.employee?.language) {
                                            case "en":
                                                return data.nameEN;
                                            case "no":
                                                return data.nameNO;
                                            case "dk":
                                                return data.nameDK;
                                            case "fi":
                                                return data.nameFI;
                                            case "sv":
                                                return data.name;
                                            default:
                                                return data.nameEN;
                                        }
                                    })()}
                                    sx={{
                                        fontFamily: '"Yllw Sans a1 241219", sans-serif',
                                        backgroundColor: props.product.categories?.includes(data.id)
                                            ? "black"
                                            : "white",
                                        color: props.product.categories?.includes(data.id)
                                            ? "white"
                                            : "black",
                                        border: props.product.categories?.includes(data.id)
                                            ? "none"
                                            : "1px solid black",
                                    }}
                                />
                            ))}
                    </ChipsContainer>
                </Card>
            )}
        </Container>
    );
};

const ListItem = styled.li`
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    justify-content: space-between;
    margin: 0.5rem;
`;
const IconActionsWrapper = styled.div`
    display: flex;
    align-items: center;
    width: 100%;
    justify-content: center;
    gap: 5px;
`;
const StyledCardActions = styled(CardActions)`
    display: flex;
    width: 100%;
    font-size: 3rem;
    border-bottom: 1px solid #ebebeb;
    //background-color: #ebebeb;
    align-items: center;
`;
const Container = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100vh;
`;
const ChipsContainer = styled.div`
    margin-top: 15px;
    margin-bottom: 30px;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 5px;
`;
